export class DiaryFormOptionTranslation {
  id: string = null;
  diaryFormElementOptionId: string;
  culture: string;
  text: string;

  constructor(init?: Partial<DiaryFormOptionTranslation>) {
    Object.assign(this, init);
  }
}
